<template>
  <ComboboxWithCustomSearch
    class="mb-0 pb-0"
    v-model="branchFilterArray"
    :label="this.$t('cards.branches')"
    :items="branches"
    itemText="name"
    itemValue="branchId"
    :prepend-icon="'mdi-source-branch'"
    style="z-index: 1000"
    :searchFunction="searchBranchesForFilter"
  />
</template>

<script>
import ComboboxWithCustomSearch from '@/components/FiltersComponent/ComboboxWithCustomSearch';

export default {
  components: {
    ComboboxWithCustomSearch,
  },
  props: {
    branchFilterValue: Array,
    bankFilterArray: Array,
  },
  model: {
    prop: 'branchFilterValue',
    event: 'branchFilterValueEv',
  },
  data() {
    return {
      branchFilterArray: [], // tempFilter
      branches: [], // branches by selected banks
      banksByBranches: [], // selected banks after select branch
    };
  },
  mounted() {},
  watch: {
    bankFilterArray: async function() {
      if (!this.bankFilterArray || this.bankFilterArray.length == 0) {
        this.branches = [];
        this.branchFilterArray = [];
        this.banksByBranches = [];

        return;
      }

      this.dropBanksByBranchesId();
      this.updateBranches();
    },
    branchFilterValue() {
      this.branchFilterArray = this.branchFilterValue;
    },
    branchFilterArray() {
      this.$emit('branchFilterValueEv', this.branchFilterArray);
    },
  },
  methods: {
    dropBanksByBranchesId() {
      this.banksByBranches = this.banksByBranches.filter(
        (id) =>
          this.bankFilterArray.find((bank) => bank.bankId === id) !== undefined
      );
    },
    dropFromBrFiltArr() {
      // drop non actual branches from filter
      this.branchFilterArray = this.checkBranchArrByBanksFilter(
        this.branchFilterArray
      );
    },
    updateBranches() {
      this.dropFromBrFiltArr();
      this.removeOldBranches();

      this.getAndSetNewBranches();
    },
    getAndSetNewBranches() {
      const newBanksId = this.getNewBanks();

      if (!newBanksId || newBanksId.length === 0) return;

      this.setNewBranchesByBanksId(newBanksId);
    },
    removeOldBranches() {
      // remove branches, if banks removed from filter
      this.branches = this.checkBranchArrByBanksFilter(this.branches);
    },
    getNewBanks() {
      var newBanksId = [];
      const len = this.bankFilterArray.length;

      for (var i = 0; i < len; i++) {
        const bankId = this.bankFilterArray[i].bankId;
        const isBankByBranch =
          this.banksByBranches.find((id) => id === bankId) === undefined;
        const isSelectedBank =
          this.branchFilterArray.find(
            (branchInfo) => bankId === branchInfo.bankId
          ) === undefined;

        if (isBankByBranch || isSelectedBank) newBanksId.push(bankId);

        if (isBankByBranch && !isSelectedBank)
          this.banksByBranches.push(bankId);
      }

      return newBanksId;
    },
    setNewBranchesByBanksId(banksId) {
      if (!banksId || banksId.length === 0) return;

      this.$axios.branches
        .getByBanksArrayForCards(banksId)
        .then((response) => response.data)
        .then((json) => {
          this.branches = this.branches.concat(json);
          this.addBranchesToBranchFilterArray(json);
        });
    },
    addBranchesToBranchFilterArray(newBranches) {
      // new branches after selected banks
      const branches = newBranches.filter(
        (branch) =>
          this.banksByBranches.find((bankId) => branch.bankId === bankId) ===
          undefined
      );

      if (branches !== undefined)
        this.branchFilterArray = this.branchFilterArray.concat(branches);
    },
    checkBranchArrByBanksFilter(branchArr) {
      return branchArr.filter(
        (branchInfo) =>
          this.bankFilterArray.find(
            (bank) => bank.bankId === branchInfo.bankId
          ) !== undefined
      );
    },
    searchBranchesForFilter(val) {
      if (
        this.bankFilterArray === undefined ||
        this.bankFilterArray === null ||
        this.bankFilterArray.length === 0
      )
        return this.searchByAllBranches(val);
      else return this.searchByBranches(val);
    },
    async searchByAllBranches(val) {
      const params = {
        query: JSON.stringify({ branchName: !val ? '' : val }),
        limit: 10,
        offset: 0,
      };

      let res;

      await this.$axios.cards
        .branches(params)
        .then((response) => response.data)
        .then((json) => (res = json.slice(0, 10)));

      return res;
    },
    searchByBranches(val) {
      const q = (val || '').toLowerCase().trim();
      if (!q) return Promise.resolve(this.branches.slice(0, 10));
      const filtered = this.branches.filter((branch) =>
        (branch.name || '').toLowerCase().includes(q)
      );

      return Promise.resolve(filtered);
    },
  },
};
</script>
